import CrudTable from '../../crud/CrudTable'
import { disabledaysService as service } from '../../../services'

const moment = require('moment')

const initFilter = {
    car: null,
    company: null,
    cartype: null,
}

export default function Disabledays() {
    const paintCell = {
        day: (value, object) => {
            if (value) {
                try {
                    return (
                        <span>
                            {moment(Date.parse(value)).format('DD/MM/YYYY')}
                        </span>
                    )
                } catch (e) {
                    return <span> -- </span>
                }
            } else {
                return <span> -- </span>
            }
        },
        name: (value, object) => {
            return <>{value}</>
        },
    }

    return (
        <CrudTable
            service={service}
            urledit={'/disabledays/edit/'}
            urlnew={'/disabledays/new/'}
            hiddenFilter={true}
            filter={initFilter}
            paintCell={paintCell}
            deleteaction={true}
            notexport={true}
            i18n={'disableday'}
            fieldstable={['day', 'name']}
        />
    )
}
